// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import firebase from 'firebase/app';
import store from './store';
import auth from 'firebase/auth'



Vue.config.productionTip = false

  var firebaseConfig = {
    apiKey: "AIzaSyC1GYrGZ4GEQSwc1QWI0HpyCtRu7WY5P2I",
    authDomain: "corridor-1.firebaseapp.com",
    projectId: "corridor-1",
    storageBucket: "corridor-1.appspot.com",
    messagingSenderId: "563851353240",
    appId: "1:563851353240:web:822bb53f54145c7279c4ed",
    measurementId: "G-90S7D0XP1N"
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);

window.firebase = firebase;

  const unsubscribed  = firebase.auth().onAuthStateChanged(user =>{
    //dispatching user
    store.dispatch('setUser', user)
    new Vue({
        el: '#app',
        router,
        store,
        components: { App },
        template: '<App/>'
    });

    //recursion
    unsubscribed()
 })


/* eslint-disable no-new */




// WEBPACK FOOTER //
// ./src/main.js